// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3nf9h","sendOtp":"AuthorizeToLogin_sendOtp__2ZZ-P"};